import { render, staticRenderFns } from "./PageSettingsFont.vue?vue&type=template&id=1696dbaa"
import script from "./PageSettingsFont.vue?vue&type=script&lang=ts"
export * from "./PageSettingsFont.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1696dbaa')) {
      api.createRecord('1696dbaa', component.options)
    } else {
      api.reload('1696dbaa', component.options)
    }
    module.hot.accept("./PageSettingsFont.vue?vue&type=template&id=1696dbaa", function () {
      api.rerender('1696dbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/document-settings/PageSettingsFont.vue"
export default component.exports